import React, { useEffect, useState } from "react";
import AddIcon from "@material-ui/icons/Add";
import Fab from "@mui/material/Fab";
import "../../../index.scss";
import "./OperatorPage.scss";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { getWorkersOfOrganization } from "../../../services/utilsOperator/utilsOperator";

import SearchBar from "../../../components/searchBar/searchBar";
import WorkerCard from "../../../components/supervisor/OperatorCard/WorkerCard";
import SignalWifiConnectedNoInternet4Icon from "@mui/icons-material/SignalWifiConnectedNoInternet4";

const WorkerPage = () => {
  const [inputWorker, setInputWorker] = useState("");
  const [workerListDefault, setWorkerListDefault] = useState([]);
  const [WorkersList, setWorkersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const fetchData = async () => {
    let fkOrganization = localStorage.getItem("fk_organization");
    // let fkOrganization = 1;
    getWorkersOfOrganization(fkOrganization)
      .then((data) => {
        //setFranchisesList(data["franchises"]);
        // console.log(data["workers"]);
        setWorkersList(data["workers"]);
        setWorkerListDefault(data["workers"]);
        setLoading(false);
      })
      .catch((error) => {
        setLoadingError(true);
        setLoading(false);
      });
  };

  const updateInputFranchise = async (input) => {
    const filtered = workerListDefault.filter((operator) => {
      return (
        operator["user"].first_name
          .toLowerCase()
          .includes(input.toLowerCase()) ||
        operator["user"].last_name.toLowerCase().includes(input.toLowerCase())
      );
    });
    setInputWorker(input);
    setWorkersList(filtered);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <main className="section-body">
      <h1 className="section-title">
        <FormattedMessage id="operatorTitle" />
      </h1>
      <article>
        <Link to="trabajadores/create">
          <Fab size="small" color="primary" className="fab" aria-label="edit">
            <AddIcon className="fab-icon" />
          </Fab>
        </Link>
        {!loading && !loadingError && (
          <>
            {workerListDefault && (
              <SearchBar
                input={inputWorker}
                onChange={updateInputFranchise}
                nombre="Trabajadores"
              />
            )}
            <div>
              <div className="franchises-continer">
                {WorkersList &&
                  WorkersList.map((worker, i) => (
                    <WorkerCard worker={worker} key={i}></WorkerCard>
                  ))}
              </div>
            </div>
          </>
        )}
        {loading && (
          <div className="d-flex justify-content-center spinner-container">
            <div className="spinner-border spinner-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        {loadingError && (
          <div className="center-container-wifi">
            <div className="wifi">
              <SignalWifiConnectedNoInternet4Icon />
            </div>
            <p>
              Lo sentimos, parece que no tienes conexión a Internet en este
              momento.
            </p>
          </div>
        )}
      </article>
    </main>
  );
};

export default WorkerPage;
